export const NO_IMG_URL = 'https://static.wplus.ca/assets/noimage.png';

export const CANCEL_HOLD_PERMISSION = 'HOLD_ORDER';
export const CANCEL_ORDER_PERMISSION = 'CANCEL_ORDER';
